import React, { useState } from 'react';
import addIcon from '../../../../Assets/Icons/add.svg'
import Table from './TableWrapper';
import AddComponentForm from '../AddComponentForm';

const MyComponent = () => {
    const [isOpen, setIsOpen] = useState(false);
    const FlagValue = 1;

    const openForm = () => {
        setIsOpen(true)
    }
    return (
        <div className='py-6 h-[70vh]'>
            <div className='flex justify-end w-full items-center'>
                <button className='text-[#1976D2] flex border-[#1976D2] border px-4 py-1 text-sm items-center rounded-md' onClick={openForm}><img src={addIcon} alt='icon' className='w-[14px] h-[14px]' />Component</button>
            </div>

            <div>
                <Table />
            </div>
            {isOpen && <div className=''><AddComponentForm isOpen={isOpen} setIsOpen={setIsOpen} flagVal={FlagValue} /> </div>}
        </div>);
}

export default MyComponent